module.exports = "data:image/svg+xml,module.exports = __webpack_public_path__ + 'fonts/jdf-logoc40bd6a53d00fd6c2f656fb08b8a2dc9.svg';"